var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['v-ribbon', ("v-ribbon--" + _vm.position)]},[_c('div',{class:['v-ribbon__wrapper']},[_c('div',{class:[
        'v-ribbon__wrapper__rotate',
        'font-weight-bold',
        ("bg-" + _vm.color)
      ]},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }